@if (newCard) {
  <div class="card">
    <div class="card-header"><ng-content select="[card-header]"></ng-content></div>
    <div class="card-body"><ng-content select="[card-body]"></ng-content></div>
    <div class="card-footer"><ng-content select="[card-footer]"></ng-content></div>
  </div>
}
@if (!newCard) {
  <card cardClasses="risk-card extra-padding">
    <div class="row" card-header><ng-content select="[header]"></ng-content></div>
    <div class="row" card-content><ng-content select="[content]"></ng-content></div>
  </card>
}
